export default __webpack_public_path__ + "static/media/work_3.0d42edec.jpg";